const navItems = document.querySelectorAll('.navbar__item');
const navButtons = document.querySelectorAll('.site-nav__link--button');
const activeClass = 'site-nav--item-open';
var returnFocusTo;

function closeDropdown() {
    navItems?.forEach(item => {
        item.classList.remove(activeClass);
    });
    navButtons?.forEach(button => {
        button.setAttribute('aria-expanded', false);
    });
}

function returnFocus() {
    if (typeof window.returnFocusTo !== 'undefined') {
        window.returnFocusTo.focus();
    }
}

function trapFocus(trap, focusFirst = true) {
    const focusableElements = 'button:not([tabindex="-1"]), [href]:not([tabindex="-1"]), input, select, textarea, [tabindex]:not([tabindex="-1"]), iframe';
    const firstFocusableElement = trap.querySelectorAll(focusableElements)[0]; // get first element to be focused inside trap
    const focusableContent = trap.querySelectorAll(focusableElements);
    const lastFocusableElement = focusableContent[focusableContent.length - 1]; // get last element to be focused inside trap

    document.addEventListener('keydown', function (e) {
        let isTabPressed = e.key === 'Tab' || e.keyCode === 9;

        if (!isTabPressed) {
            return;
        }

        if (e.shiftKey) { // if shift key pressed for shift + tab combination
            if (document.activeElement === firstFocusableElement) {
                lastFocusableElement.focus(); // add focus for the last focusable element
                e.preventDefault();
            }
        } else { // if tab key is pressed
            if (document.activeElement === lastFocusableElement) { // if focused has reached to last focusable element then focus first focusable element after pressing tab
                firstFocusableElement.focus(); // add focus for the first focusable element
                e.preventDefault();
            }
        }
    });
    if (focusFirst) {
        setTimeout(() => {
            firstFocusableElement.focus();
        }, 350);
    }
}

navButtons?.forEach(button => {
    button.addEventListener('click', e => {
        e.preventDefault();
        // close the open item only
        if (button.parentElement.classList.contains(activeClass)) {
            closeDropdown();
            return;
        }
        // close all then open this one
        closeDropdown();
        button.parentElement.classList.add(activeClass);
        button.setAttribute('aria-expanded', true);
        trapFocus(document.getElementById(button.getAttribute('aria-controls')), false);
        returnFocusTo = button;
    });
});

document.addEventListener('keyup', e => {
    let isEscape = false;
    if ("key" in e) {
        isEscape = (e.key == "Escape" || e.key == "Esc");
    } else {
        isEscape = (e.keyCode == 27);
    }
    if (isEscape) {
        closeDropdown();
        returnFocus();
    }
});

